import React, { useCallback } from 'react';
import { Typography } from 'antd';

import { fetchCollectionRecentlyDeleted } from '../../services/history';
import RecentlyDeleted from '../history/RecentlyDeleted';

const { Paragraph } = Typography;

/**
 * Settings › Recently deleted (delete audit F5): the collection's deleted
 * cards, element sets and items, newest first, each with Restore — the
 * history revert of its delete. Manage-gated on the API like the History tab
 * beside it. A card came back one way before this — the card's own History,
 * inside a card nobody could open — and an item only through the History
 * feed; this is the list that answers "what did we lose, and can it come
 * back".
 *
 * `onRestored` lets the settings form around it re-read the collection: a
 * card's restore puts it back in `cards[]` and moves `updatedAt`, and a form
 * still holding the old `updatedAt` would answer its own next save with 409
 * `stale_collection`.
 */
export default function CollectionRecentlyDeleted({ collectionId, onRestored }) {
	const fetchPage = useCallback(
		paging => fetchCollectionRecentlyDeleted(collectionId, paging),
		[collectionId]
	);
	if (!collectionId) return null;
	return (
		<div className='settings-column recently-deleted-tab'>
			<Paragraph type='secondary'>
				Cards, element sets and items deleted from this collection. Restoring one brings it back as it was when it was deleted — an item with its links and, for 30 days, its attachments.
			</Paragraph>
			{/* The 10b contract's one line: an item's files — attachments and the
			    files its file elements hold — outlive it by 30 days, not forever. */}
			<Paragraph type='secondary' data-testid='recently-deleted-files'>
				Files are kept for 30 days after the item is deleted.
			</Paragraph>
			<RecentlyDeleted
				key={collectionId}
				fetchPage={fetchPage}
				onRestored={onRestored}
				emptyText='Nothing deleted from this collection is waiting to be restored.'
			/>
		</div>
	);
}
